var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoyalty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0987",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 22,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01107 4.83333C3.36062 4.83333 2.83333 5.36062 2.83333 6.01107V17.6675C2.83333 18.3179 3.36062 18.8452 4.01107 18.8452H19.9889C20.6394 18.8452 21.1667 18.3179 21.1667 17.6675V6.01107C21.1667 5.36062 20.6394 4.83333 19.9889 4.83333H4.01107ZM1 6.01107C1 4.3481 2.3481 3 4.01107 3H19.9889C21.6519 3 23 4.3481 23 6.01107V17.6675C23 19.3305 21.6519 20.6786 19.9889 20.6786H4.01107C2.3481 20.6786 1 19.3305 1 17.6675V6.01107ZM9.07566 14.5779L8.41108 13.9729L8.40527 13.9676C6.04811 11.8302 4.49233 10.4194 4.49233 8.68832C4.49233 7.27666 5.6015 6.16749 7.01316 6.16749C7.81066 6.16749 8.57608 6.53874 9.07566 7.12541C9.57525 6.53874 10.3407 6.16749 11.1382 6.16749C12.5498 6.16749 13.659 7.27666 13.659 8.68832C13.659 10.4164 12.1086 11.8253 9.75834 13.961L9.74025 13.9775L9.07566 14.5779ZM19.5818 17.5188V13.6009H18.5903V17.5188H19.5818ZM18.0811 17.5188V13.6009H16.5686V17.5188H18.0811ZM16.0595 17.5188V13.6009H15.068V17.5188H16.0595ZM14.5588 17.5188V13.6009H13.5674V17.5188H14.5588Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0987)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/Loyalty.d68c3060.svg";
export { ForwardRef as ReactComponent };